import React, { useState, useEffect } from 'react';
import { GridRenderer } from './GridRenderer';
import { useAPIQuery } from '@/components/data/useAPIQuery';
import DefaultError from '@/components/data/DefaultError';
import SkeletonTable from './SkeletonTable';

import APIError461 from '@/components/data/APIError461';
import APIErrorGeneric from '@/components/data/APIErrorGeneric';

const DataGrid = ({ config }) => {

  // Extract and process pagination values once with defaults
  const getDefaultPageIndex = () => (config.page ? config.page - 1 : 0);
  const getDefaultPageSize = () => config.page_size || 10;

  let url = config.query;
  let options = config.query?.options || {};

  if (!options.placeholderData) options.placeholderData = (previousData) => previousData;

  const [pagination, setPagination] = useState({
    pageIndex: getDefaultPageIndex(),
    pageSize: getDefaultPageSize(),
  });

  // Add this useEffect to sync pagination state with config changes
  useEffect(() => {
    setPagination({
      pageIndex: getDefaultPageIndex(),
      pageSize: getDefaultPageSize(),
    });
  }, [config.page, config.page_size]);

  // Update URL parameters during render
  if (url && typeof url === 'object') {
    if (!url.parameters) url.parameters = {};
    url.parameters.page = pagination.pageIndex + 1;
    url.parameters.page_size = pagination.pageSize;
  }

  console.log('DataGrid', url, config, options, pagination);

  const { data, isLoading, isFetching, isError, error, refetch } = useAPIQuery(url, {
    ...options,
  });

  if (isLoading) {
    return <SkeletonTable />;
  }

  if (isError) {
    return <DefaultError error={error} refetch={refetch} />;
  }

  if (data?.ErrorCode) {
    if (data.ErrorCode === 461) return <APIError461 data={data} />

    return <APIErrorGeneric data={data} />
  }

  if (!data) return null;

  let itemsName = config.items || "items";

  // Check if data[itemsName] exists and is an array
  if (data[itemsName] && Array.isArray(data[itemsName])) {
    const items = data[itemsName];
    return <GridRenderer
      data={items}
      config={config}
      state={{ pagination }}
      onPaginationChange={setPagination}
      isBusy={isLoading || isFetching}
    />;
  } else {
    console.error(`${itemsName} not found in response or is not an array`, data);
    return null;
  }
};

export { DataGrid };